module.exports = __webpack_public_path__ + "static/media/location-maps-letter-g-arrow-serr2.86b5a1df.png";